import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ToolboxItemService } from 'src/app/_core/services/toolbox-item.service';
import { ProjectService } from 'src/app/_core/services/project.service';
import { Door } from 'src/app/_core/models/doors/door.model';
import { AreaType } from 'src/app/_core/interfaces/IAreaType';
import { StylingService } from 'src/app/_core/services/styling.service';
import { LayerLevel } from 'src/app/_core/interfaces/LayerLevel';
import { NON_EXPORT_COLOR } from 'src/app/_core/constants/constants';
import { FrameProfile } from 'src/app/_core/models/profiles/frame.model';

@Component({
	selector: 'g[app-door]',
	templateUrl: './door.component.html',
	styleUrls: ['./door.component.css']
})
export class DoorComponent {
	@Input() selectedItems: any[];
	@Input() area: string;
	@Input() printMode: boolean;
	@Output() selectDoorEvent = new EventEmitter<Door>();
	@Output() selectFrameEvent = new EventEmitter<FrameProfile>();

	constructor(private toolBSrvc: ToolboxItemService,
		private projectService: ProjectService,
		public styling: StylingService) {

	}

	selectDoor(d: Door) {
		this.selectDoorEvent.emit(d);		
		this.toolBSrvc.setCurrTool(null);
	}

	selectFrame(d: Door, f: FrameProfile) {
		f.master = d;
		this.selectFrameEvent.emit(f);
		this.toolBSrvc.setCurrTool(null);
	}

	getDoors() {
		if (!this.styling.showLayer(LayerLevel.Middle)) {
			return null;
		}
		return this.projectService.profileService.getDoors(AreaType[this.area]);
	}

	iconClass(itemType: string, areaType: string): string {
		return this.toolBSrvc.iconClass(itemType, areaType);
	}

	getGlassBackColor(d: Door): string {
		if (d.inOffer) {
			return `url(#color_${d.glassColor.substring(1)})`;
		} else {
			return NON_EXPORT_COLOR;
		}
	}

}
